class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }
  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }
  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }
  renderContents(parsedState) {
      console.log('🛒 [cart-notification] renderContents called with parsedState:', parsedState);
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('🛒 [cart-notification] Fetched cart data:', cart);
          console.log('🛒 [cart-notification] Cart item_count:', cart.item_count);
          this.updateCartBadgeCount(cart.item_count);
        })
        .catch(error => {
          console.error('🛒 [cart-notification] Error fetching cart:', error);
          const itemCount = parsedState.items?.length || 1;
          this.updateCartBadgeCount(itemCount);
        });

      if (this.header) this.header.reveal();
      this.open();
  }
  updateCartBadgeCount(itemCount) {
    console.log('🛒 [cart-notification] updateCartBadgeCount called with itemCount:', itemCount);
    const cartBadges = document.querySelectorAll('.wbhcartitem');
    console.log('🛒 [cart-notification] Found badges:', cartBadges.length, cartBadges);
    cartBadges.forEach((badge, index) => {
      console.log(`🛒 [cart-notification] Badge ${index}:`, badge, 'Current display:', badge.style.display, 'Current text:', badge.textContent);
      if (itemCount > 0) {
        badge.textContent = itemCount;
        if (badge.classList.contains('wbqtyboth')) {
          badge.style.display = 'flex';
          console.log(`🛒 [cart-notification] Badge ${index} set to flex`);
        } else {
          badge.style.display = 'inline-block';
          console.log(`🛒 [cart-notification] Badge ${index} set to inline-block`);
        }
      } else {
        badge.style.display = 'none';
        console.log(`🛒 [cart-notification] Badge ${index} hidden`);
      }
    });
    
    const cartTotals = document.querySelectorAll('.wbcarthtotal');
    console.log('🛒 [cart-notification] Found cart totals:', cartTotals.length);
    cartTotals.forEach(total => {
      if (itemCount > 0) {
        total.style.display = 'block';
      } else {
        total.style.display = 'none';
      }
    });
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-price',
        selector: `[id="cart-notification-price-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      }
    ];
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  // handleBodyClick(evt) {
  //   const target = evt.target;
  //   if (target !== this.notification && !target.closest('cart-notification')) {
  //     const disclosure = target.closest('details-disclosure');
  //     this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
  //     this.close();
  //   }
  // }
  handleBodyClick(evt) {
    const target = evt.target;
    const modalContent = this.notification.querySelector('.cart-notification-inner');

    if (!modalContent.contains(target)) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-notification', CartNotification);
